/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAccessCatalog } from '../../models/api-response-access-catalog';

export interface GetAccessCatalog$Params {
  'x-api-requestId'?: string;
  'x-api-canal'?: string;
}

export function getAccessCatalog(http: HttpClient, rootUrl: string, params?: GetAccessCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAccessCatalog>> {
  const rb = new RequestBuilder(rootUrl, getAccessCatalog.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAccessCatalog>;
    })
  );
}

getAccessCatalog.PATH = '/v1/api/ui/access-catalog';
